import React, { useMemo } from "react";
import { Modal, Typography } from "antd";
import moment from 'moment'
const { Text } = Typography;

export default function BatchDelete({
  visible,
  onCancel,
  onConfirm,
  selectedRowKeys,
  selectedRow
}) {

  // 是否存在未过期账户
  const isAvailable = useMemo(() => {
    return selectedRow.some(row => {
      return row?.expired_at && moment().isBefore(moment(row?.expired_at).endOf('day'))
    })
  }, [selectedRow])
  return (
    <Modal
      title="批量删除学员账户"
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="删除"
      cancelText="取消"
      okButtonProps={{ danger: true }}  // 红色按钮
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        
        <Text>
          当前已选中 <Text strong>{selectedRowKeys.length}</Text> 个学员账户，是否确定删除？删除后这批学员将再也无法登录其账户，其账户内的数据也会被删除。
        </Text>

        {/* <Text type="secondary">
          删除后这批学员将再也无法登录其账户，其账户内的数据也会被删除。
        </Text> */}
        {/* 是否存在可用的账户 */}
        {isAvailable && <Text style={{ color: '#FAAD14' }}>
          注意：目前选中的学员账户中，有部分账户的有效期还未到期，请确保已经和授课教师、学员沟通确认可以删除这些账户。
        </Text>}

      </div>
    </Modal>
  );
}
